import { useEffect, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getContentType } from '../../../Utils/helper';
import { downloadAppHandler } from '../../../Utils/redirections';
import {
  CenterDiv,
  Title,
  TitleNumberDiv,
  TrustGrid,
  TrustNumber,
  TrustSection,
  TrustTitle,
  WhyParentingContent,
} from './styled';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function ParentingTrustStrip() {
  const [gridCardSignal, setGridCardSignal] = useState({
    index: '',
    show: false,
  });
  useEffect(() => {
    fireServedSectionEvent(
      "INDIA'S MOST TRUSTED PARENTING PLATFORM",
      null,
      getContentType(),
    );
  }, []);
  const trustFactorData = [
    {
      trustNumber: '4.8',
      title: 'Rated App on playstore',
      image: images.filledStar,
      seubHeading: ' Most trusted in parenting',
    },
    {
      trustNumber: '200+',
      title: 'Top Experts',
      seubHeading: 'Expert Verified Content',
    },
    {
      trustNumber: '10+ Million',
      title: 'HAPPY YOUNG PARENTS',
      seubHeading: ' Helpful community',
    },
    {
      trustNumber: '7500+',
      title: 'Articles & videos',
      seubHeading: 'on 500+ Topics',
    },
  ];
  return (
    <TrustSection>
      <CenterDiv>
        <Title>
          INDIA&apos;S <strong> MOST TRUSTED</strong> PARENTING PLATFORM
        </Title>
        <TrustGrid>
          {trustFactorData?.map((ele, index) => {
            return (
              <div
                onClick={(e) => {
                  e.preventDefault();
                  setTimeout(() => {
                    downloadAppHandler();
                  }, [200]);
                  setGridCardSignal({
                    index: index,
                    show: true,
                  });
                }}
                className={
                  gridCardSignal.index === index
                    ? 'gridcardopacity transitionClass'
                    : 'transitionClass'
                }
                key={`div_${index}`}
              >
                <TitleNumberDiv>
                  <TrustNumber>
                    {ele?.trustNumber}
                    {ele?.image ? (
                      <img src={ele?.image} alt="star" className="star_image" />
                    ) : null}
                  </TrustNumber>
                  <TrustTitle>{ele.title}</TrustTitle>
                </TitleNumberDiv>
                <WhyParentingContent>{ele?.seubHeading}</WhyParentingContent>
              </div>
            );
          })}

          {/* <div>
                        <TitleNumberDiv>
                            <TrustNumber>200+</TrustNumber>
                            <TrustTitle>Top Experts</TrustTitle>
                        </TitleNumberDiv>
                        <WhyParentingContent>
                            Expert Verified Content
                        </WhyParentingContent>
                    </div>
                    <div>
                        <TitleNumberDiv>
                            <TrustNumber>10+ Million</TrustNumber>
                            <TrustTitle>HAPPY YOUNG PARENTS</TrustTitle>
                        </TitleNumberDiv>
                        <WhyParentingContent>
                            Helpful community
                        </WhyParentingContent>
                    </div>

                    <div>
                        <TitleNumberDiv>
                            <TrustNumber>7500+</TrustNumber>
                            <TrustTitle>Articles &amp; videos</TrustTitle>
                        </TitleNumberDiv>
                        <WhyParentingContent>
                            on 500+ Topics
                        </WhyParentingContent>
                    </div> */}
        </TrustGrid>
      </CenterDiv>
    </TrustSection>
  );
}
